import { doc, setDoc } from "firebase/firestore";
import { analytics, authIa, dbIa } from "../firebase";
import semanticScholarApi, { SearchResponseItem } from "../SemanticScholarApi";

import * as Sentry from "@sentry/react";
import { logEvent } from "firebase/analytics";
import { getPapersById } from "../cloudFunctions/getPapersById";

const articleLoader = async ({
  params,
}: {
  params: {
    articleId: string;
    slug: string;
  };
}) => {
  const { articleId } = params;

  logEvent(analytics, "open_article");

  const result = await new Promise<SearchResponseItem>((resolve, reject) => {
    getPapersById({
      papers_id: [parseInt(articleId, 10)],
    })
      .then((res) => {
        console.log(articleId);
        const papers = res.data.papers;
        console.log("papers", res.data);
        const article = papers[0];
        console.log("article", article);
        if (!article) {
          reject(new Error("Article not found"));
          return;
        }
        setDoc(
          doc(
            dbIa,
            "users",
            authIa.currentUser?.uid as string,
            "history",
            articleId
          ),
          {
            readAt: new Date(),
            id: articleId,
          }
        );
        resolve(article);
      })
      .catch((error) => {
        Sentry.captureException(error);
        reject(error);
      });
  });

  return {
    article: result,
  };
};

const backupArticleLoader = async ({
  params,
}: {
  params: {
    articleId: string;
    slug: string;
  };
}) => {
  const { articleId } = params;

  logEvent(analytics, "open_article");

  const result = await new Promise<SearchResponseItem>((resolve) => {
    semanticScholarApi.search
      .get(`/paper/CorpusId:${articleId}`, {
        params: {
          fields:
            "corpusId,url,title,venue,publicationVenue,year,authors,externalIds,abstract,citationCount,influentialCitationCount,isOpenAccess,openAccessPdf,s2FieldsOfStudy,publicationTypes,publicationDate,journal,tldr,citationStyles",
        },
      })
      .then(async (res) => {
        const result = res.data;

        try {
          setDoc(
            doc(
              dbIa,
              "users",
              authIa.currentUser?.uid as string,
              "history",
              articleId
            ),
            {
              readAt: new Date(),
              id: articleId,
            }
          );
        } catch (error) {
          Sentry.captureException(error);
        }

        resolve(result);
      });
  });

  return {
    article: result,
  };
};

export { articleLoader, backupArticleLoader };
